"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[8849],{

/***/ 88849:
/***/ ((module) => {

module.exports = JSON.parse('{"logout":"Log out","language":"Language","swedish":"Swedish","english":"English","dutch":"Dutch","questionsAndAnswers":"Questions & Answers","manual":"Manual","filmedGuides":"Video guides","chatWithSupport":"Chat with support","remoteSupport":"Remote support","facebookUserGroup":"Facebook user group","downloadProgram":"Download programs","giveFeedback":"Give feedback","firmSupport":"Lundify Workflow","createNewNote":"Create a new Note/To do","getStartedWithAml":"Get started with AML","partnerProgram":"Partner program","firmSettings":"Firm settings","help":"Help"}');

/***/ })

}]);